import React, { useRef } from 'react';
import { Button, Input, Select } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

export type LocationItem = {
  item_name: string;
  capacity: number;
  operation: 'pickup' | 'drop_off';
};

type Props = {
  value: LocationItem[];
  onChange: (items: LocationItem[]) => void;
};

const generateKey = (): string => `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const ItemsEditor = ({ value, onChange }: Props): JSX.Element => {
  const items = value ?? [];
  const keysRef = useRef<string[]>([]);

  while (keysRef.current.length < items.length) {
    keysRef.current.push(generateKey());
  }

  while (keysRef.current.length > items.length) {
    keysRef.current.pop();
  }

  const addItem = () => {
    keysRef.current.push(generateKey());

    onChange([
      ...items,
      {
        item_name: '',
        capacity: 0,
        operation: 'pickup',
      },
    ]);
  };

  const removeItem = (index: number) => {
    keysRef.current.splice(index, 1);
    onChange(items.filter((_, i) => i !== index));
  };

  const updateItem = (index: number, field: keyof LocationItem, newValue: any) => {
    onChange(items.map((item, i) => (i === index ? { ...item, [field]: newValue } : item)));
  };

  return (
    <div>
      {items.map((item, index) => (
        <div key={keysRef.current[index]} style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
          <Input
            placeholder="Item name"
            value={item.item_name}
            onChange={(e) => updateItem(index, 'item_name', e.target.value)}
            style={{ width: 120 }}
          />

          <Input
            type="number"
            placeholder="Capacity"
            value={item.capacity}
            min={0}
            onChange={(e) => updateItem(index, 'capacity', Number(e.target.value))}
            style={{ width: 70 }}
          />

          <Select
            value={item.operation}
            onChange={(operation) => updateItem(index, 'operation', operation)}
            style={{ width: 100 }}
          >
            <Select.Option value="pickup">Pickup</Select.Option>
            <Select.Option value="drop_off">Drop Off</Select.Option>
          </Select>

          <Button icon={<DeleteOutlined />} danger size="small" onClick={() => removeItem(index)} />
        </div>
      ))}

      <Button icon={<PlusOutlined />} size="small" onClick={addItem}>
        Add Item
      </Button>
    </div>
  );
};

export default ItemsEditor;
